import { useMinicartRecommendations } from "../../hooks/use-minicart-recommendations";
import { MMUpsellProductList } from "../features/upsell/MMUpsellProductList";
import {
  SearchResultProvider,
  type SearchResult,
} from "@made-people/grease-search";

export const MMMinicartUpsell = () => {
  const { recommendations, loading } = useMinicartRecommendations("standard");

  const result: SearchResult | undefined = recommendations.length
    ? {
        items: recommendations.map((product) => ({
          type: "product" as const,
          product,
        })),
        meta: {
          totalItems: recommendations.length,
          totalPages: 1,
          itemsPerPage: recommendations.length,
          currentPage: 1,
        },
        facets: [],
        sort: [],
      }
    : undefined;

  if (!recommendations.length && !loading) return null;

  return (
    <SearchResultProvider result={result}>
      <MMUpsellProductList
        heading="Mini_Cart_Recommendations_Heading"
        context="minicart"
      />
    </SearchResultProvider>
  );
};
